{{ value$ | async }}
